import { motion } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";
import { CTA_BLOCK, CONTACT } from "../../data/content";
import { Reveal } from "../motion/Motion";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function CtaBlock() {
  return (
    <section data-testid="cta-block" className="relative overflow-hidden bg-brand-primary py-16 md:py-28">
      {/* decorative image */}
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1920&q=80"
          alt=""
          aria-hidden="true"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-brand-primary via-brand-primary/95 to-brand-primary/70" />
      <motion.div
        aria-hidden="true"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        className="absolute left-0 top-0 h-1.5 w-full origin-left bg-brand-accent"
      />

      <div className="relative mx-auto max-w-[1100px] px-6 text-center md:px-12">
        <Reveal>
          <h2 className="mx-auto max-w-3xl font-heading text-3xl font-extrabold leading-[1.1] tracking-tight text-white sm:text-4xl lg:text-5xl">
            {CTA_BLOCK.title}
          </h2>
        </Reveal>
        <Reveal delay={0.08}>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-white/70">
            {CTA_BLOCK.subtitle}
          </p>
        </Reveal>
        <Reveal delay={0.16}>
          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <button
              data-testid="cta-block-primary"
              onClick={() => scrollTo("#kapcsolat")}
              className="group flex items-center justify-center gap-2 bg-brand-accent px-8 py-4 font-semibold text-white transition-all duration-300 hover:bg-brand-accentDark"
            >
              {CTA_BLOCK.primaryCta}
              <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </button>
            <a
              href={CONTACT.phoneHref}
              data-testid="cta-block-phone"
              className="flex items-center justify-center gap-2 border border-white/30 px-8 py-4 font-semibold text-white transition-all duration-300 hover:bg-white/10"
            >
              <Phone size={18} />
              {CONTACT.phone}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
